import * as _ from 'underscore'
import { IIconSet as IIconSet_Mvc, IconSet as IconSet_Mvc } from 'mappMvc/const'

export interface IIconSet  extends IIconSet_Mvc {
	ApiKey: string;
	Area: string;
	AttributeData: string;
	Back: string;
	BarChart: string;
	BiMap: string;
	Cache: string;
	Charge: string;
	Content: string;
	ContextAction: string;
	Copyright: string;
	Crs: string;
	Cube: string;
	DataGridAction: string;
	Database: string;
	Download: string;
	Export: string;
	FeatureAction: string;
	FeatureAnalyzer: string;
	Filter: string;
	GIS: string;
	Globus: string;
	Hidden: string;
	Home: string;
	Imagery: string;
	Import: string;
	Invalid: string;
	Jobs: string;
	Key: string;
	Launch: string;
	Layers: string;
	Legend: string;
	LegendAction: string;
	LineChart: string;
	Logs: string;
	MApps: string;
	OpenFolder: string;
	Orders: string;
	OverView: string;
	Phone: string;
	Play: string;
	PrintLayouts: string;
	Publish: string;
	PublishVector: string;
	PublishWmts: string;
	Queries: string;
	Questionmark: string;
	Refresh: string;
	Select: string;
	Services: string;
	Shell: string;
	SpatialModels: string;
	StyleSets: string;
	Table: string;
	Tasks: string;
	TileGrid: string;
	Time: string;
	TopAction: string;
	Update: string;
	Upload: string;
	User: string;
	Users: string;
	VectorData: string;
	VectorSet: string;
	Web: string;
	Windows: string;
	Workflows: string; 
}; 

export var IconSet: IIconSet = _.extend({}, IconSet_Mvc, {
	ApiKey: 'mapp-studio-icons-api-key',
	Area: 'mapp-studio-icons-object-group',
	AttributeData: 'mapp-studio-icons-table',
	Back: 'mapp-studio-icons-reply',
	BarChart: 'mapp-studio-icons-bar-chart',
	BiMap: 'hehe-icons-pie',
	Cache: 'hehe-icons-input',
	Charge: 'mapp-studio-icons-charge',
	Content: 'hehe-icons-content',
	ContextAction: 'mapp-studio-icons-action-set-context',
	Copyright: 'mapp-studio-icons-copyright',
	Crs: 'mapp-studio-icons-customcrs',
	Cube: 'mapp-studio-icons-cube',
	DataGridAction: 'mapp-studio-icons-action-set-datagrid',
	Database: 'mapp-studio-icons-data',
	Download: 'mapp-studio-icons-import',
	Export: 'hehe-icons-export',
	FeatureAction: 'mapp-studio-icons-action-set-feature',
	FeatureAnalyzer: 'mapp-studio-icons-featureanalyzer',
	Filter: 'mapp-studio-icons-filter',
	GIS: 'mapp-studio-icons-screen-desktop',
	Globus: 'hehe-icons-globus',
	Hidden: 'mapp-studio-icons-eye-disabled',
	Home: 'mapp-studio-icons-home',
	Imagery: 'hehe-icons-tiles',
	Import: 'hehe-icons-import',
	Invalid: 'mapp-studio-icons-ban',
	Jobs: 'mapp-studio-icons-calendar',
	Key: 'mapp-studio-icons-key',
	Launch: 'hehe-icons-launch',
	Layers: 'hehe-icons-dataviewer',
	Legend: 'hehe-icons-analitics',
	LegendAction: 'mapp-studio-icons-action-set-legend',
	LineChart: 'mapp-studio-icons-line-chart',
	Logs: 'mapp-studio-icons-info',
	MApps: 'hehe-icons-myaaps',
	OpenFolder: 'hehe-icons-models',
	Orders: 'mapp-studio-icons-clipboard',
	OverView: 'mapp-studio-icons-overview',
	Phone: 'mapp-studio-icons-phone',
	Play: 'mapp-studio-icons-play-circle-o',
	PrintLayouts: 'mapp-studio-icons-print',
	Publish: 'hehe-icons-input',
	PublishVector: 'mapp-studio-icons-publish-vector',
	PublishWmts: 'mapp-studio-icons-publish-wmts',
	Queries: 'hehe-icons-preview',
	Questionmark: 'hehe-icons-more',
	Refresh: 'hehe-icons-refresh',
	Select: 'hehe-icons-select',
	Services: 'hehe-icons-build',
	Shell: 'mapp-studio-icons-terminal',
	SpatialModels: 'hehe-icons-mindmap',
	StyleSets: 'hehe-icons-customize',
	Table: 'hehe-icons-list',
	Tasks: 'mapp-studio-icons-tasks',
	TileGrid: 'hehe-icons-tiles',
	Time: 'hehe-icons-time',
	TopAction: 'mapp-studio-icons-action-set-top',
	Update: 'mapp-studio-icons-bell-o',
	Upload: 'mapp-studio-icons-upload',
	User: 'hehe-icons-user',
	Users: 'mapp-studio-icons-users',
	VectorData: 'mapp-studio-icons-handle-streamline-vector',
	VectorSet: 'mapp-studio-icons-vector-set',
	Web: 'mapp-studio-icons-browser-streamline-window',
	Windows: 'mapp-studio-icons-windows',
	Workflows: 'hehe-icons-workflow' 
});